// src/app/modules/reportsGeneracionDocumentos/ReportPageGeneracionDocumentos.tsx
import { Navigate, Routes, Route } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { ReportList } from './ReportList'
import PermissionsService from '../auth/PermissionsService'

const ReportPageGeneracionDocumentos: React.FC = () => {
  const intl = useIntl()
  const userBreadCrumbs: Array<PageLink> = [
    { title: 'Reportes', path: 'generacion-documentos-reports/', isSeparator: false, isActive: false },
    { title: '',          path: '',                             isSeparator: true,  isActive: false },
  ]

  const perms = PermissionsService.getPermissions()
  const canView = perms?.hasConsumptionReportGenerateDocumentsPermission ?? false

  return (
    <Routes>
      {/* Cuando entres a /generacion-documentos-reports, te redirige a list */}
      <Route index element={<Navigate to="list" replace />} />

      <Route
        path="list"
        element={
          canView ? (
            <>
              <PageTitle breadcrumbs={userBreadCrumbs}>
                {intl.formatMessage({ id: 'REPORTS.GENERACION_DOCUMENTOS.TITLE', defaultMessage: 'Reportes Generación Documentos' })}
              </PageTitle>
              <ReportList />
            </>
          ) : (
            <Navigate to="/error/403" replace />
          )
        }
      />
    </Routes>
  )
}

export default ReportPageGeneracionDocumentos
